import { cB as i, cE as o, c as n } from "../../../_utils/cssr/index.js";
const e = i("empty", `
 display: flex;
 flex-direction: column;
 align-items: center;
 font-size: var(--n-font-size);
`, [o("icon", `
 width: var(--n-icon-size);
 height: var(--n-icon-size);
 font-size: var(--n-icon-size);
 line-height: var(--n-icon-size);
 color: var(--n-icon-color);
 transition:
 color .3s var(--n-bezier);
 `, [n("+", [o("description", `
 margin-top: 8px;
 `)])]), o("description", `
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), o("extra", `
 text-align: center;
 transition: color .3s var(--n-bezier);
 margin-top: 12px;
 color: var(--n-extra-text-color);
 `)]);
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/empty/src/styles/index.cssr.js
// module id = 1688
// module chunks = 67